var exports = {
  "ZO": "MessageContextPrefix.module__channelHeader___ajJadm",
  "wO": "MessageContextPrefix.module__channelHeaderCompact___ajJadm",
  "p": "MessageContextPrefix.module__channelIcon___ajJadm",
  "uS": "MessageContextPrefix.module__channelIconAvatar___ajJadm",
  "bR": "MessageContextPrefix.module__channelIconAvatarImage___ajJadm",
  "D4": "MessageContextPrefix.module__channelNameButton___ajJadm",
  "Kw": "MessageContextPrefix.module__channelNameText___ajJadm",
  "Vf": "MessageContextPrefix.module__channelNamePrimary___ajJadm",
  "S4": "MessageContextPrefix.module__channelScopeRow___ajJadm",
  "AQ": "MessageContextPrefix.module__channelScopeGuildIcon___ajJadm",
  "oN": "MessageContextPrefix.module__channelScopeGuildName___ajJadm",
  "V$": "MessageContextPrefix.module__channelScopeChevron___ajJadm",
  "fm": "MessageContextPrefix.module__channelScopeChannelInfo___ajJadm",
  "Gn": "MessageContextPrefix.module__channelScopeChannelIcon___ajJadm",
  "wF": "MessageContextPrefix.module__channelScopeChannelName___ajJadm",
  "bo": "MessageContextPrefix.module__focusRingTight___ajJadm",
};

module.exports = exports;
